var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0_450_1362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_450_1362",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_450_1362",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_450_1362",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABNJJREFUeAHtnctuGzcUho0AcZ/BiV+hm+6ySIH0ggJt8wJBtzFshOdwtOp2nqlJNtnHDRK73XbfTREgG7u5bdr6uFI94mgkksO/oqU/gGFphucc8vuGlC3Rk52d6b+2bXe9984590JE/lTVv/l1xWDK5GdVfWSsZtwg351zt1T1Fwq4ErCMhYicNk2zB5FhtikjTkQg6eTg4OBmcSm2TAWFuFRFLtciclRciL1mBEJ+siWseKFrnnAymdxW1cddViJyXHxYqnreLWKFixfZkIQist9lJSJnxYfWLWCPixfYsIRwXvACFJJGgEIq40UhFJJGoLLW8AsYXqAyoGO7A+cFLzCWQGXxcF7wApUBHdsdOC94gbEEKouH84IXqAzo2O7AecELjCVQWTycF7xAZUDHdgfOC15gLIHK4kXkxy6z4t3rJrfHxQtsYMKulOLDo5A8pDMpedFLoihkCZwVp1S1XdEk/TSFpDODRlAIFG96cgpJZwaNoBAo3vTkFBLHzDn3qao+c849bZrms7iojFYUEgct2Ex4LiJ34yITW1FIHDBV/T1ghZESFOFv6gN+vPcPQ1a2p817//lASN7hsEhelu2IEpFGVf8KmL1V1XvFCATJOUNWkB2S4pz7YkVo3GkKiePUbQWVQiFd1PGPYVIoJF5C2BIihUJCzGnPh6So6pdpmaatKSQL21xQUSkUMsc2+0kxKRSS7aAXOCRFRL7qNR46QCFDZPKOL5IiIu+ipVBIHvhlUaOkUMgytPnnsqVQSD70VZGLpKjqBxH5bjCWQgbRFDmRLIVCinBfmiRJCoUsZVns5JAU7/33c0UoZA4H9EmUFAqBOuglXyRFRD5e3GHo/mXjdQvx3v+gqq/Dfmzh8/fe+292woH3lAIP2O2N7LfYsA9b/PztWoWIyCeqap9J85ZQ/zJYrxCbfN77ByLyB6Xo+pcs4GpYberpi3q4Inz478ff8MqsdiQb0LGVMmyMFPL/mB6S0Xtfi0LwQqJlcIasR4b9qO+9/3phdc6QhViKHFw0M1Z+ekghRdj3kmTJsCwU0mM5+kC2DAoZzb6XYJEMezeCmxx6qPAHhmQk7WLkklVGVBEZ1hUKGS9kSEbW34xQyDghRWVwhlQmg0LyhRSfGbOucMmakYj/DpNhXaCQeBHWckhGsb/EpZB4IXAZnCHxMux/ZwsvXt44IJ5f0Za2O2bBZgzeWqMo5YRkbdveEJE3nRmCkWF96hS5/OA9oZ9b1VRVvxWR35xzvzZNcwc2eAqBoc1LTCF53GBRFAJDm5eYQvK4waIoJB8tb6Scz654pMmwixmReG6fafECG5hwJoNCKpDblUEhdQjBrih8UU+zDOcFL5A23upbw3nBC1SPOK2DcF7wAmnjrb41nBe8QPWI0zoI5wUvkDbe6lvDecELVI84rYNwXvACaeOtvjWcF7xA9YjTOgjnBS+QNt7qW8N5wQtUjzitg3BeInLWLSIi+2ld3J7WxiZgdVZ89M65F90iqvp4MpncLl7omic0Gd77J11WInJcfFgDO/Lm3tHsdoKP5+5cdFhcSNu2uxd3Mzsl6DnQKy9IEXlpOxqLC7GETdPsqeoJpcRJ8d6/MmYQGbOk07u7Hanqc9tETDk9OcbE2BzCZsaFjH8AXh/nYnOC8uIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8a861d8fb66d322f0b255a0da4e0304d.svg";
export { ForwardRef as ReactComponent };